import { MentionBlot } from 'quill-mention'

/** Normalize API profilePicture (string or object) to a usable image URL */
export const resolveProfilePictureUrl = (picture) => {
    if (!picture) return ''
    if (typeof picture === 'string') return picture.trim()
    if (typeof picture === 'object') {
        return (
            picture.url ||
            picture.URL ||
            picture.Location ||
            picture.href ||
            picture.path ||
            ''
        )
    }
    return ''
}

export const getMentionInitials = (name) => {
    const text = name == null ? '' : String(name).trim()
    if (!text) return 'U'
    const parts = text.split(/\s+/).filter(Boolean)
    if (parts.length >= 2) {
        const a = parts[0][0]
        const b = parts[1][0]
        if (a != null && b != null) {
            return `${a}${b}`.toUpperCase()
        }
    }
    return text.slice(0, 2).toUpperCase()
}

export const getMentionAvatarColor = (name) => {
    if (!name) return '#e2e8f0'
    const colors = [
        '#85BBF9',
        '#6366f1',
        '#8b5cf6',
        '#ec4899',
        '#f59e0b',
        '#10b981',
        '#06b6d4',
    ]
    const index = name.charCodeAt(0) % colors.length
    return colors[index]
}

export const buildMentionPillElement = (data = {}) => {
    const wrap = document.createElement('span')
    wrap.className = 'mention-editor-pill'

    const avatarEl = document.createElement('span')
    avatarEl.className = 'mention-editor-pill-avatar'

    const displayName = data.value || ''
    const avatarUrl = resolveProfilePictureUrl(data.avatar)

    if (avatarUrl) {
        const img = document.createElement('img')
        img.src = avatarUrl
        img.alt = displayName
        img.referrerPolicy = 'no-referrer'
        img.onerror = () => {
            img.remove()
            avatarEl.textContent = getMentionInitials(displayName)
            avatarEl.style.backgroundColor = getMentionAvatarColor(displayName)
        }
        avatarEl.appendChild(img)
    } else {
        avatarEl.textContent = getMentionInitials(displayName)
        avatarEl.style.backgroundColor = getMentionAvatarColor(displayName)
    }

    const nameEl = document.createElement('span')
    nameEl.className = 'mention-editor-pill-name'
    nameEl.textContent = displayName

    wrap.appendChild(avatarEl)
    wrap.appendChild(nameEl)
    return wrap
}

const isMentionData = (data) =>
    data &&
    typeof data === 'object' &&
    'value' in data &&
    typeof data.value === 'string'

class AvatarMentionBlot extends MentionBlot {
    static render(data) {
        return buildMentionPillElement({
            ...data,
            avatar: resolveProfilePictureUrl(data?.avatar),
        })
    }

    static create(data) {
        const node = super.create()
        if (!isMentionData(data) || !(node instanceof HTMLElement)) {
            return node
        }

        const payload = {
            ...data,
            avatar: resolveProfilePictureUrl(data.avatar),
            denotationChar:
                typeof data.denotationChar === 'string' ? data.denotationChar : '',
        }

        node.contentEditable = 'false'
        node.appendChild(this.render(payload))
        return MentionBlot.setDataValues(node, payload)
    }
}

export default AvatarMentionBlot
